import {TreatmentTarget} from './treatment_target'
export class SMSTreatment extends TreatmentTarget {
  constructor() {
    super();
  }

  validate() {
    let response = {}
    this.querySelectorAll('textarea').forEach((input) => { 
      input.classList.remove("error")
      if(input.value === "") {
        input.classList.add("error")
        response.requiredMissing = true 
      }
    });
    return response;
  }

  getData() {
    return {type:"SMS", template:this.querySelector("textarea").value, action_timing: 1 }
  }

  isTarget() {
    return false;
  }

  getIcon() {
    return 'fa-comment'
  }

  static getType() {
    return "SMS"
  }

  connectedCallback() {
    this.innerHTML = 
      `<div class="col-sm-12 ct_action" data-action_type=SMS>
        <div class="panel panel-default">
          <h4>Text Message to Caller</h4><a class="remove"><i class="fa fa-times" aria-hidden="true"></i></a>
          <div class="form-group">
              <label for="exampleInputPassword1">Text Message</label>
              <div class="sms_form_group">
                <textarea class="form-control" style="width: 100%; height: 4em; resize: none;">${this.action != null ? this.action.action_template.template : ""}</textarea>
              </div>
          </div>
        </div>
      </div>
      <div class="col-sm-12 ct_line">
        <div class="ct_vertical_arrow"></div>
        <div class="option_text">Sent Text Message</div>
        <div class="ct_vertical_arrow">
          <div class=arrow-down></div>
        </div>
      </div>
    `;
    super.connectedCallback();
  }
}

customElements.define('sms-treatment', SMSTreatment);